import { Chip } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

type MissingLanguagesChipProps = {
  /** Codes of the content languages a text is missing in. */
  missing: Array<string>;
};

/** Marks a row whose text is not translated into every content language; nothing when it is. */
export const MissingLanguagesChip = ({ missing }: MissingLanguagesChipProps) => {
  const t = useT();

  return missing.length === 0 ? null : (
    <Chip
      size="small"
      color="warning"
      variant="outlined"
      label={t('languages.missingIn', { codes: missing.map((code) => code.toUpperCase()).join(', ') })}
      sx={{ ml: 1 }}
    />
  );
};
